import React from 'react'

export default function Home() {
    return (
        <div>
            <h5 className="text-center">Coming Soon!</h5>
        </div>
    )
}
